/* eslint-disable react/react-in-jsx-scope */
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import { ReactElement } from "react";

export interface BagdeProps {
  height?: number | string;
  width?: number | string;
  variante?: "dashed" | "outlined" | "contained";
  value: string | ReactElement;
  fontSize?: number | string;
  color?: string;
  parcel?: boolean;
  background?: string;
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: "auto",
      marginBottom: "auto",
      borderRadius: "50%",
      textAlign: "center",
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
    },
    root2: {
      display: "flex",
      textAlign: "center",
      justifyItems: "center",
      justifyContent: "center",
      marginTop: "auto",
      marginBottom: "auto",
    },
    root3: {
      height: "16px",
      width: "16px",
      backgroundColor: "#fff",
      marginTop: "-12px",
      marginBottom: "auto",
      borderRadius: "50%",
      color: "#399ebf",
      textAlign: "center",
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      position: "relative",
      right: "7px",
      [theme.breakpoints.down("xs")]: {
        marginLeft: 124,
        marginTop: -14,
      },
    },
    root4: {
      display: "flex",
      textAlign: "center",
      justifyItems: "center",
      justifyContent: "center",
      margin: "auto",
      marginBottom: "auto",
    },
  })
);

export const Bagde = ({
  height = "20px",
  width = "20px",
  variante = "dashed",
  value,
  fontSize = 16,
  color = "#f2994a",
  parcel = false,
  background = "#fff",
}: BagdeProps) => {
  const styles = useStyles();
  return (
    <div>
      {parcel ? (
        <div
          className={styles.root}
          style={{
            height,
            width,
            backgroundColor: background,
            color,
          }}
        >
          <span
            className={styles.root2}
            style={{
              fontSize,
            }}
          >
            {value}
          </span>
        </div>
      ) : (
        <Grid className={styles.root3} item xs={12}>
          <span
            className={styles.root4}
            style={{
              fontSize,
            }}
          >
            {value}
          </span>
        </Grid>
      )}
    </div>
  );
};

export default Bagde;
